import { render, staticRenderFns } from "./ColumnsLayout.vue?vue&type=template&id=4aa72d22&"
import script from "./ColumnsLayout.vue?vue&type=script&lang=ts&"
export * from "./ColumnsLayout.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports